// ----------------------------
// Created by Bulletproof Games
//            2017
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Options Button

buyBonusButton = {};

buyBonusButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);
  InputHelpers.addInfoPlatformEnabledFlag(button);

  button._flags.credit = {
    balance: 0,
  };

  button.shuffle = resourceManager.get('shuffler');

  button.canEnable = function () {
    if (checkForUndefined(this.gameConfig)) return false;

    const buyBonusData = this.gameConfig.data.slotConfig.gameModes.BONUS_BUY;
    let validStake = false;
    if (buyBonusData !== undefined) {
      validStake = true;
    }
    var canEnable =
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      !button._sideMenuOpen &&
      validStake &&
      !button.isPromotion &&
      button.hasValidStakes() &&
      !gdk.serverParser._inReplayMode;

    resourceManager.get(this.name + ':button').alpha = canEnable ? 1 : 0.5;

    return canEnable;
  };

  button.hasValidStakes = function () {
    let validStakes = false;
    if (checkForUndefined(this.gameConfig) !== true) {
      const buyBonusDataSuperFreeSpins = this.gameConfig.data.slotConfig.gameModes.BONUS_BUY_XTRA;
      const buyBonusDataFreeSpins = this.gameConfig.data.slotConfig.gameModes.BONUS_BUY;

      if (
        (buyBonusDataSuperFreeSpins !== undefined && buyBonusDataSuperFreeSpins.coinSizes.length !== 0) ||
        (buyBonusDataFreeSpins !== undefined && buyBonusDataFreeSpins.coinSizes.length !== 0)
      ) {
        validStakes = true;
      }
    }

    return validStakes;
  };

  button.buyBonusAllowed = function () {
    return gdk.getRegulatedMarket() !== 'UK';
  };

  button.canShow = function () {
    if (checkForUndefined(this.gameConfig)) return false;

    return !this.shuffle._inShuffle && button.hasValidStakes() && gdk.getPlatformAllowsBuyBonus();
  };

  button.showButton = function () {
    if (this.canShow() && this.buyBonusAllowed()) {
      if (!button._flags.showbuyBonusActive) {
        this.button.visible = true;
      } else {
        this.button.visible = false;
      }
      this.visible = true;
    } else {
      if (!this.buyBonusAllowed()) {
        this.button.visible = false;
      }
    }
  };

  button.onPressedCallback = function () {
    // disable lucky bet button

    buyBonusPopup.show(function () {});
    if (button.soundName !== '') button.playSound();
  };

  button.onGameConfig = function (event) {
    this.gameConfig = event;
  };

  button.onCreditChanged = function (creditTask) {
    this._flags.credit.balance = creditTask.data.balance;
  };

  button.onStakeChanged = function (stake) {
    this._flags.stake = stake;
  };

  button.promotionStarted = function () {
    button.isPromotion = true;
  };

  button.promotionEnded = function () {
    button.isPromotion = false;
  };

  button.sideMenuOpenMsg = function () {
    button._sideMenuOpen = true;
  };

  button.sideMenuClosedMsg = function () {
    button._sideMenuOpen = false;
  };

  messageBus.subscribe('game:sideMenuOpen', button.sideMenuOpenMsg.bind(button));
  messageBus.subscribe('game:sideMenuClosed', button.sideMenuClosedMsg.bind(button));
  messageBus.subscribe('common:BalanceEvent', button.onCreditChanged.bind(button));
  messageBus.subscribe('spinner:GameConfigEvent', button.onGameConfig.bind(button));
  messageBus.subscribe('stake:stakeChanged', button.onStakeChanged.bind(button));
  messageBus.subscribe('common:PromotionStarted', button.promotionStarted.bind(button));
  messageBus.subscribe('common:PromotionEnded', button.promotionEnded.bind(button));

  return button;
};

buyBonusButton.initialise = function (json, object) {
  object.soundName = json.soundName || '';
};
buyBonusButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  'buyBonusButton',
  buyBonusButton.create,
  buyBonusButton.initialise,
  buyBonusButton.getFilesRequired
);
